  <ion-grid class="ion-no-padding">
    <ion-row>
      <ng-container *ngFor="let p of player; trackBy: trackById; let i = index">
        <ion-col size="{{matchType === 'S' ? '12' : '6'}}">
          <ion-item
            class="player-item {{selectedPlayerId === p.person._id ? 'selected-player' : ''}}"
            (click)="getPlayerId(p)"
          >
            <ion-thumbnail slot="start">
              <img
                *ngIf="p?.person?.profile_image; else defaultAvatar"
                [src]="p?.person?.profile_image"
                alt="Profile Image"
              />
              <ng-template #defaultAvatar>
                <ion-icon class="avatarImage" name="person-circle-outline"></ion-icon>
              </ng-template>
            </ion-thumbnail>
  
            <ion-label class="ion-text-center {{!p?.jerseyNumber ? 'no-jersey' : ''}}">
              <strong *ngIf="p?.jerseyNumber">#{{ p.jerseyNumber }}</strong>
              <span>{{ p.person.last_name }} {{ p.person.first_name }} </span>
            </ion-label>
  
            <ion-checkbox
              slot="end"
              [checked]="selectedPlayerId === p.person._id"
              (click)="$event.stopPropagation()"
            ></ion-checkbox>
          </ion-item>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>